import { format } from 'date-fns';
import { pickLatestFlexibleDate } from '@ourbranch/date-helpers';

import { DATE_FORMAT } from 'core/helpers/formatters';

/**
 * Resolve the "last inspection date" to display for a policy (#33158).
 *
 * The most recent inspection date is the later of two sources, in either format:
 *   - `storedDate`: Policy.lastInspectionDate, an AWSDate ('yyyy-MM-dd') set by UW entry,
 *     migration, or the renewal creator.
 *   - `inspectionDateCompleted`: the current term's live completed inspection
 *     (getInspectionStatus.dateCompleted), a vendor string that may be ISO or US ('MM/dd/yyyy').
 *
 * The flexible-format parsing + "pick the later date" logic is shared with the renewal-stamping
 * backend via @ourbranch/date-helpers so the two sides can't drift. Returns a 'MM/dd/yyyy' display
 * string, or null when neither source has a usable date.
 */
export const resolveLastInspectionDate = ({ storedDate, inspectionDateCompleted } = {}) => {
  const latest = pickLatestFlexibleDate(storedDate, inspectionDateCompleted);
  return latest ? format(latest, DATE_FORMAT) : null;
};
